export default __webpack_public_path__ + "static/header-75c71408322e5465247bb89391d4a0c2.mp4";